/**
 * Debug / diagnostics module — public surface (009).
 *
 * This is the ONLY entry point the rest of the app may import from. All debug
 * collection, UI, logging, recording, and export live behind these four symbols
 * (FR-012). Deleting this directory + the two host lines in main.tsx returns the
 * app to its baseline behaviour (SC-007).
 */
import { isDebugEnabled } from './flag.js'
import { installPcTap } from './pcRegistry.js'

export { isDebugEnabled } from './flag.js'
export { debugLog } from './logBuffer.js'
export { DebugRoot } from './DebugRoot.js'

/**
 * Install debug hooks. Call once, as early as possible (before the app creates
 * any RTCPeerConnection). No-op unless debug is enabled, so disabled = inert.
 */
export function installDebug(): void {
  if (!isDebugEnabled()) return
  installPcTap()
}
